import { ChangeDetectionStrategy, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { DispatcherService } from '@frontend/sports/common/core/utils/dispatcher';
import { PropType } from '@frontend/sports/common/core/utils/extended-types';
import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';
import { ToasterService } from '@frontend/sports/toaster/feature';
import { distinctUntilChanged } from 'rxjs';

import { ColumnLayoutService } from '../layout/column-layout.service';
import { MultiBuilderTrackingService } from './multi-builder-tracking.service';
import { MultiBuilderDispatcherEvents } from './multi-builder.model';
import { MultiBuilderService } from './multi-builder.service';

@Component({
    selector: 'ms-multi-builder-combo-prevention-error',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MultiBuilderComboPreventionErrorComponent {
    private hasComboPreventionError = false;
    betslipErrorMessages: PropType<PropType<Sitecore, 'betslip'>, 'errors'>;

    constructor(
        public sitecore: Sitecore,
        private multiBuilderTracking: MultiBuilderTrackingService,
        private toasterService: ToasterService,
        private routerEventsService: RouterEventsService,
        private layoutManager: ColumnLayoutService,
        private dispatcherService: DispatcherService,
        private multiBuilderService: MultiBuilderService,
    ) {
        this.betslipErrorMessages = sitecore.betslip.errors;
        this.dispatcherService
            .on(MultiBuilderDispatcherEvents.BetslipComboPreventionError)
            .pipe(distinctUntilChanged(), takeUntilDestroyed())
            .subscribe((data) => this.onMultiComboPreventionError(data));
        this.routerEventsService.currentActivationEnd.pipe(takeUntilDestroyed()).subscribe((event) => this.toggleComboErrorMessageToaster());
        this.dispatcherService
            .on(MultiBuilderDispatcherEvents.OnPopupClosed)
            .pipe(takeUntilDestroyed())
            .subscribe((popupname) => this.onPopupClosed(popupname));
    }

    private onPopupClosed(popupname: string): void {
        if (popupname === 'betslip') {
            this.multiBuilderService.setComboErrorToasterOpened(false);
        }
    }

    private onMultiComboPreventionError(hasComboError: boolean): void {
        this.hasComboPreventionError = hasComboError;
        if (this.hasComboPreventionError) {
            this.multiBuilderTracking.trackBetSlipErrors();
        }
        this.toggleComboErrorMessageToaster();
    }

    get showMultiBuilderComboPreventionError(): boolean {
        return !this.layoutManager.layout.isRightVisible && this.hasComboPreventionError;
    }

    private toggleComboErrorMessageToaster(): void {
        if (this.showMultiBuilderComboPreventionError && !this.multiBuilderService.isComboErrorToasterOpened) {
            this.toasterService.open(this.betslipErrorMessages.NonCombinablePicks, {
                icon: 'theme-error-i',
                panelClass: 'multibuilder-toaster-panel',
            });
            this.multiBuilderService.setComboErrorToasterOpened(true);
        } else {
            this.toasterService.dismiss();
            this.multiBuilderService.setComboErrorToasterOpened(false);
        }
    }
}
